import { useParams } from "react-router-dom";
import ArtifactTable from "../../components/ArtifactTable";
import { MODULES } from "../../config/modules";

export default function ArtifactPage({ type }) {
  const { projectId } = useParams();
  const config = MODULES[type];
  if (!config) return <div>Unknown module</div>;
  return <ArtifactTable key={type} projectId={projectId} type={type} config={config} />;
}
